import { UtilForms } from './../../../utils/util-forms';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UtilMasks } from 'src/app/utils/util-masks';
import { ResgateConsultaService } from 'src/app/services/http/resgate-consulta.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resgate-consulta',
  templateUrl: './resgate-consulta.component.html',
  styleUrls: ['./resgate-consulta.component.scss']
})
export class ResgateConsultaComponent implements OnInit {

  placaControl = new FormControl('', [Validators.required, Validators.minLength(7)]);
  chassiControl = new FormControl('', [Validators.required, Validators.maxLength(17)]);
  motorControl = new FormControl('', [Validators.required, Validators.maxLength(99)]);
  cpf_cnpjControl = new FormControl('', [Validators.required]);
  idControl = new FormControl('', [Validators.required]);
  tipoConsulta = new FormControl('', [Validators.required]);

  tipoPesquisaVeiculo = 'placa';

  masks = {
    placa: {mask: UtilMasks.placa, guide: false},
    idlaudo: {mask: UtilMasks.idLaudo, guide: false},
    documento: { mask:  UtilMasks.documento, guide: false}
  };

  ufOptions:any = UtilForms.optionsEstado.nome;

  constructor(private router: Router, private modalMsgService: ModalMsgService, private resgatarConsultaService: ResgateConsultaService) {}

  ngOnInit() {
  }

  formSubmit() {
    if(this.idControl.invalid) return;
    if(this.tipoPesquisaVeiculo=='placa' && this.placaControl.invalid) return;
    if(this.tipoPesquisaVeiculo=='chassi' && this.chassiControl.invalid) return;
    if(this.tipoPesquisaVeiculo=='motor' && this.motorControl.invalid) return;
    if(this.tipoPesquisaVeiculo=='cpf_cnpj' && this.cpf_cnpjControl.invalid) return;

    let data = {
      placa: this.tipoPesquisaVeiculo=='placa' ? this.placaControl.value : '',
      chassi: this.tipoPesquisaVeiculo=='chassi' ? this.chassiControl.value : '',
      motor: this.tipoPesquisaVeiculo=='motor' ? this.motorControl.value : '',
      cpf_cnpj: this.tipoPesquisaVeiculo=='cpf_cnpj' ? this.cpf_cnpjControl.value: '',
      idConsulta: this.idControl.value,
      consultaRealizada: '',
    };

    this.modalMsgService.open('Deseja realizar o resgate da seguinte consulta?',
    'ID: ' + this.idControl.value + ' - ' +
    (this.tipoPesquisaVeiculo=='placa' ? 'Placa: ' + this.placaControl.value.toUpperCase()
    : this.tipoPesquisaVeiculo=='chassi' ? 'Chassi: ' + this.chassiControl.value.toUpperCase()
    : this.tipoPesquisaVeiculo=='cpf_cnpj' ? 'CPF/CNPJ: ' + this.cpf_cnpjControl.value.toUpperCase()
    : 'Motor: ' + this.motorControl.value.toUpperCase() ), 'success' )
    .then(r => {
      if(r=='ok') {
        this.resgatarConsultaService.resgatarConsulta(data).then(result => {
          if( result['status'] ){
            this.modalMsgService.openDialog(result['msg'], '', 'success').then(r => {
              this.router.navigate(['consulta','resultado', result['id']]);
            }).catch(r => {
              this.router.navigate(['consulta','resultado', result['id']]);
            });
          }else{
            this.modalMsgService.openDialog('Erro ao efetuar operação', result['msg'], 'warning')
          }
        }).catch(e => {
          this.modalMsgService.openDialog('Erro ao efetuar operação',
          e.status == '403' ?
          'O prazo para resgatar a consulta é de 336 horas (14 dias)'
          : 'Consulta não encontrada, verifique se os dados estão corretos e tente novamente', 'danger')
        });
      }
    })
  }

}
